import { Col, Row, Typography } from 'antd';
import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { useFetchUserDataQuery } from '@/store/apis/userApi';
import { useEffect, useState } from 'react';
import Meeting from '@/components/Meeting/Meeting';

export const BookAMeetingPage = () => {
  const { data: userProfileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const userProfile = userProfileData?.data;
  const [meetingUrl, setMeetingUrl] = useState<string>(
    'https://meetings.hubspot.com/pau-lam/tax-consultation',
  );
  useEffect(() => {
    if (!userProfile) return;

    try {
      const params = new URLSearchParams({
        embed: 'true',
        ...(userProfile?.firstName && { firstname: userProfile?.firstName }),
        ...(userProfile?.lastName && { lastname: userProfile?.lastName }),
        ...(userProfile?.email && { email: userProfile?.email }),
        ...(userProfile?.phone && { phone: userProfile?.phone }),
      });

      // Only update if we successfully built params
      if (params.toString()) {
        setMeetingUrl(
          `https://meetings.hubspot.com/pau-lam/tax-consultation?${params}`,
        );
      }
    } catch (error) {
      console.error('Error building meeting URL:', error);
      // meetingUrl stays as the fallback URL
    }
  }, [userProfile]);

  return (
    <div
      style={{
        margin: '1rem auto',
      }}
    >
      <Row>
        <Col xs={24} lg={12}>
          <Meeting meetingUrl={meetingUrl} title="Book a Meeting" />
        </Col>
      </Row>
    </div>
  );
};

export default BookAMeetingPage;
